<template>
	<el-checkbox-group size="small" v-model="allStatus">
		<el-checkbox-button v-for="item in options" :key="item.value" :label="item.value" @change="changeValue">{{item.label}}</el-checkbox-button>
	</el-checkbox-group>
  
</template>

<script>
export default {
  name: 'selectJcBussinessStatus',
  props:{
		allStatus:0
	}, 
  data() {
    return {
      options: [
        {
          value: 2,
          label: '检查成功',
        },
        {
          value: 3,
          label: '检查失败',
        },
      ],
    };
  },

  mounted() {
    
  },

  methods: {
    changeValue() {
      this.$emit('update:allStatus', this.allStatus)
      this.$emit("success",this.allStatus)
    },   
  },
};
</script>

<style lang="scss" scoped>

</style>